import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import banner1 from "../../../assets/images/objective.jpg";

function OurVision() {
  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "0%", sm: "0%" }}>
      <Box>
        <Box position={"relative"}>
          <Box
            component="img"
            height={{ xs: "120vh", sm: "650px" }}
            display={{ xs: "none", sm: "block" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              width: "100%",
            }}
            src={banner1}
            alt={"our-mission-image"}
          />
          <Box
            paddingBottom={"3%"}
            position={"absolute"}
            top={{ xs: "15%", sm: "28%" }}
            width={{ xs: "100%", sm: "95%" }}
            padding={{ xs: "0% 2% 0% 4%", sm: "0% 6%" }}
          >
            <Typography
              variant="h3"
              color={"#fff"}
              fontWeight={700}
              paddingBottom={{ xs: "5%", sm: "4%" }}
              paddingTop={{ xs: "40%", sm: "0%" }}
              textAlign={"center"}
            >
              Our Vision: A Resilient and Thriving Africa
            </Typography>
            <Box
              display={"inline-flex"}
              alignItems={"center"}
              flexWrap={"wrap"}
            >
              <Box width={{ xs: "100%", sm: "40%" }}>
                <Typography
                  variant="body1"
                  color="#fff"
                  fontWeight={400}
                  paddingBottom={"2%"}
                  textAlign={"left"}
                >
                  AIR Fund envisions secondary cities as untapped engines of
                  growth and innovation. Research indicates that targeted
                  investments in urban infrastructure, governance, and social
                  entrepreneurship could increase productivity by up to 30% in
                  these cities. Secondary cities also play a strategic role in
                  agribusiness and manufacturing, projected to grow at 8-10%
                  annually, and can alleviate pressures on overcrowded primary
                  cities by offering new opportunities for economic inclusion.
                </Typography>
              </Box>

              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                color="#fff"
                width={3}
              />
              <Box width={{ xs: "100%", sm: "40%" }}>
                <Typography
                  variant="body1"
                  color="#fff"
                  fontWeight={400}
                  paddingBottom={"2%"}
                  textAlign={"left"}
                >
                  The Fund also leverages Africa’s demographic strength, with
                  its youth population expected to double to over 800 million by
                  2050. These young innovators represent immense potential for
                  transformation. While Africa’s technology hubs have grown from
                  442 in 2018 to over 700 in 2023, most are concentrated in
                  primary cities. AIR Fund aims to position secondary cities as
                  new centers of innovation by providing resources, networks,
                  and infrastructure to support grassroots entrepreneurship and
                  youth-led solutions.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default OurVision;
